<template>
  <footer class="footer">
    <div class="container">
      <div class="footer__top">
        <div class="footer__brand">
          <AppLogo />
          <p class="text-md muted">Group-buying for electronics. Share a deal, watch the price drop.</p>
        </div>
        <nav class="footer__cols" aria-label="Footer">
          <div>
            <h2 class="footer__heading">Product</h2>
            <ul>
              <li><NuxtLink to="/search">Find a deal</NuxtLink></li>
              <li><NuxtLink to="/#trending">Trending</NuxtLink></li>
              <li><NuxtLink to="/#categories">Categories</NuxtLink> <span class="footer__new">New</span></li>
            </ul>
          </div>
          <div>
            <h2 class="footer__heading">Account</h2>
            <ul>
              <li><NuxtLink to="/orders">Order history</NuxtLink></li>
              <li><NuxtLink to="/followed">Followed deals</NuxtLink></li>
              <li><NuxtLink to="/basket">Basket</NuxtLink></li>
            </ul>
          </div>
        </nav>
      </div>
      <p class="footer__legal text-md">© {{ new Date().getFullYear() }} Regotiate. All rights reserved.</p>
    </div>
  </footer>
</template>

<style scoped>
.footer {
  background: var(--white);
  padding: 48px 0 32px;
  margin-top: 48px;
}

.footer__top {
  display: grid;
  gap: 48px;
}

.footer__brand p {
  margin-top: 24px;
  max-width: 320px;
}

.footer__cols {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 32px;
}

.footer__heading {
  font-size: 14px;
  line-height: 20px;
  font-weight: 600;
  color: var(--gray-600);
  margin-bottom: 16px;
}

.footer__cols ul {
  list-style: none;
  margin: 0;
  padding: 0;
  display: grid;
  gap: 12px;
  font-weight: 600;
  color: var(--gray-600);
}

.footer__new {
  margin-left: 8px;
  padding: 2px 8px;
  border-radius: var(--radius-pill);
  background: var(--error-50);
  color: var(--logo-red);
  font-size: 12px;
}

.footer__legal {
  margin-top: 48px;
  padding-top: 32px;
  border-top: 1px solid var(--gray-200);
  color: var(--gray-500);
}

@media (min-width: 768px) {
  .footer__top {
    grid-template-columns: 1fr 1fr;
  }
}
</style>
